// Catering Invoice Related Enums

import { RecordStatus } from '../menu/enums.types';
import { ICateringOrder } from './cateringOrder.types';

// catering_invoice paymentType Enum
export enum InvoicePaymentType {
  PERCENTAGE = 'percentage',
  FIXED = 'fixed',
}

export enum InvoiceStatus {
  PENDING = 'pending',
  PAID = 'paid',
  VOID = 'void',
}

export interface ICateringInvoice {
  id: string;
  invoiceReference: string;
  cateringOrderId: string;
  cateringOrder: ICateringOrder;
  invoiceStatus: InvoiceStatus;
  amount: number;
  orderInfo: any;
  dueDate: Date;
  paymentType: InvoicePaymentType;
  calculatedAmount: number;
  paidAmount: number;
  status: RecordStatus;
  createdAt: Date;
  updatedAt: Date;
  emailRequestedAt: Date;
}

export interface ICateringInvoiceStaus {
  status: InvoiceStatus;
  count: number;
  total: number;
}

export type CateringInvoiceFilter = Partial<ICateringInvoice>;

export interface ICateringInvoiceReq {
  cateringOrderId: string;
  amount: number;
  paymentType: InvoicePaymentType;
  installmentId?: number;
}

export interface InvoiceReferenceOptions {
  orderSlug: string;
  lastSequenceNumber?: number;
}

export interface IPaymentLinkCreationReq {
  reference: string;
  amount: number;
  commission: number;
  customerEmail: string;
  expiresAt: Date;
  accountId: string;
  metadata: any;
  store: string;
}

export interface IInvoicePayment {
  paymentAmount: number;
  paymentType: InvoicePaymentType;
  value: number;
}
export interface ICateringInvoiceEmailVariables {
  customerEmail: string;
  restaurantId: number;
  subject: string;
  heading: string;
  line1Text: string;
  line2Text: string;
  buttonText?: string;
  buttonUrl?: string;
  paymentLink?: string;
  restaurantLogo?: string;
  invoiceAmount?: string;
  cateringOrder: any;
  cc?: string[];
  bcc?: string[];
  attachInvoice?: boolean;
}

export interface IEmailContentData {
  from: string;
  to: string[];
  cc: string[];
  bcc: string[];
  subject: string;
  htmlBody: any;
  textBody: any;
  attachments: {
    contentType: string;
    filename: string;
    content: any;
  }[];
}

export interface IEmailData {
  body: any;
  from: string;
  to: string[];
  cc?: string[];
  bcc?: string[];
  subject: string;
  textBody: any;
  attachmentName?: string;
}
